<div class="modal-header">
	<h5 class="modal-title">WMS-Daten abrufen</h5>
	<button type="button" class="btn-close" aria-label="Schließen"
			[disabled]="phase === 'lauft'"
			(click)="cancel()"></button>
</div>

<div class="modal-body">
	<!-- ----------------------------------------------------------------- -->
	<!-- Phase 1: Optionen -->
	<!-- ----------------------------------------------------------------- -->
	<section *ngIf="phase === 'optionen'">
		<p class="mb-2">
			Für <strong>{{ points.length }}</strong> ausgewählte Punkte werden Klimastufe,
			Forst-/Katasteradresse und Wuchsgebiet via WMS neu abgefragt.
		</p>
		<div class="alert alert-warning small mb-3">
			Punkte werden <strong>sequentiell</strong> verarbeitet (Pause zwischen Punkten),
			damit weder die externen WMS-Server noch der Backend-Proxy eine IP-Sperre auslösen.
			Bei {{ points.length }} Punkten dauert das mindestens
			<strong>{{ ((points.length * delayMsBetweenPoints) / 1000) | number:'1.0-0' }} s</strong>
			plus die Antwortzeit der Server.
		</div>

		<div class="form-check mb-2">
			<input class="form-check-input" type="checkbox" id="wms-opt-overwrite"
				   [(ngModel)]="overwrite">
			<label class="form-check-label" for="wms-opt-overwrite">
				Vorhandene Werte überschreiben
			</label>
			<div class="form-text">
				Ohne Haken werden nur leere Felder ergänzt — empfohlen, damit manuelle
				Korrekturen erhalten bleiben.
			</div>
		</div>

		<div class="mb-2">
			<label class="form-label" for="wms-opt-delay">
				Pause zwischen Punkten (ms): <strong>{{ delayMsBetweenPoints }}</strong>
			</label>
			<input class="form-range" type="range" id="wms-opt-delay"
				   min="200" max="5000" step="100"
				   [(ngModel)]="delayMsBetweenPoints">
			<div class="form-text">
				Niedrigere Werte = schneller, aber höheres IP-Sperr-Risiko.
				Default 1000 ms ist konservativ.
			</div>
		</div>
	</section>

	<!-- ----------------------------------------------------------------- -->
	<!-- Phase 2: Lauft -->
	<!-- ----------------------------------------------------------------- -->
	<section *ngIf="phase === 'lauft'">
		<ngb-progressbar type="primary" [value]="progressPercent"
						 [animated]="true" [striped]="true">
			{{ progressDone }} / {{ progressTotal }}
		</ngb-progressbar>
		<p class="text-muted small mt-2 mb-1">Aktueller Punkt: {{ currentPointId }}</p>
		<div class="status-counts small mb-2">
			<span class="badge bg-success me-1">OK: {{ counts.ok }}</span>
			<span class="badge bg-warning text-dark me-1">übersprungen: {{ counts.skipped }}</span>
			<span class="badge bg-danger me-1">Fehler: {{ counts.errors }}</span>
		</div>

		<div *ngIf="log.length > 0" class="log-area">
			<h6 class="small text-muted">Auffällige Punkte:</h6>
			<ul class="log-list">
				<li *ngFor="let entry of log"
					[class.text-warning]="entry.status === 'skipped'"
					[class.text-danger]="entry.status === 'error'">
					<strong>{{ entry.pointId }}</strong>
					<span *ngIf="entry.status === 'skipped'">— übersprungen</span>
					<span *ngIf="entry.status === 'error'">— Fehler</span>
					<span *ngIf="entry.reason">: {{ entry.reason }}</span>
				</li>
			</ul>
		</div>
	</section>

	<!-- ----------------------------------------------------------------- -->
	<!-- Phase 3: Fertig -->
	<!-- ----------------------------------------------------------------- -->
	<section *ngIf="phase === 'fertig' && result">
		<div class="alert" [class.alert-success]="!result.aborted" [class.alert-warning]="result.aborted">
			<strong *ngIf="!result.aborted">Fertig.</strong>
			<strong *ngIf="result.aborted">Abgebrochen.</strong>
			<span class="ms-1">{{ result.ok }} aktualisiert</span>
			<span *ngIf="result.skipped > 0"> · {{ result.skipped }} übersprungen</span>
			<span *ngIf="result.errors > 0"> · {{ result.errors }} Fehler</span>
			<span class="text-muted"> (von {{ result.total }})</span>
		</div>

		<div *ngIf="log.length > 0" class="log-area">
			<h6 class="small text-muted">Auffällige Punkte:</h6>
			<ul class="log-list">
				<li *ngFor="let entry of log"
					[class.text-warning]="entry.status === 'skipped'"
					[class.text-danger]="entry.status === 'error'">
					<strong>{{ entry.pointId }}</strong>
					<span *ngIf="entry.status === 'skipped'">— übersprungen</span>
					<span *ngIf="entry.status === 'error'">— Fehler</span>
					<span *ngIf="entry.reason">: {{ entry.reason }}</span>
				</li>
			</ul>
		</div>
	</section>
</div>

<div class="modal-footer">
	<button *ngIf="phase === 'optionen'" type="button" class="btn btn-outline-secondary" (click)="cancel()">
		Abbrechen
	</button>
	<button *ngIf="phase === 'optionen'" type="button" class="btn btn-primary" (click)="start()">
		Start
	</button>

	<button *ngIf="phase === 'lauft'" type="button" class="btn btn-outline-danger" (click)="abort()">
		Stopp nach aktuellem Punkt
	</button>

	<button *ngIf="phase === 'fertig'" type="button" class="btn btn-primary" (click)="close()">
		Schließen
	</button>
</div>
